// Selección de imagen de portada de un mapa: lee el archivo, lo redimensiona en un
// canvas y lo deja como data URI en map.imgurl. No sube nada al servidor.

const MAX_IMAGE_PX = 800;
const MAX_IMAGE_BASE64 = 150000;
const JPEG_QUALITIES = [0.75, 0.6, 0.45];
const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const mapImagePicker = {
    data() {
        return {
            defaultImageURL: '/images/forest-background.jpg',
            previewError: false
        }
    },
    computed: {
        previewImageURL: function(){
            return (this.map.imgurl && !this.previewError) ? this.map.imgurl : this.defaultImageURL;
        }
    },
    methods: {
        onImageSelected: function(event){
            var that = this;
            var file = event.target.files && event.target.files[0];
            //Permite volver a elegir el mismo archivo después de un rechazo.
            event.target.value = '';
            if(!file) return;
            if(ACCEPTED_TYPES.indexOf(file.type) === -1) {
                this.showImageError('Formato no soportado. Usa una imagen JPG, PNG o WEBP.');
                return;
            }

            var reader = new FileReader();
            reader.onload = function(){
                var image = new Image();
                image.onload = function(){ that.storeResizedImage(image); };
                image.onerror = function(){ that.showImageError('No fue posible leer la imagen seleccionada.'); };
                image.src = reader.result;
            };
            reader.onerror = function(){ that.showImageError('No fue posible leer la imagen seleccionada.'); };
            reader.readAsDataURL(file);
        },
        storeResizedImage: function(image){
            var scale = Math.min(1, MAX_IMAGE_PX / Math.max(image.width, image.height));
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(image.width * scale));
            canvas.height = Math.max(1, Math.round(image.height * scale));

            var ctx = canvas.getContext('2d');
            //JPEG no tiene canal alfa: sin fondo blanco un PNG transparente sale negro.
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

            for(var i = 0; i < JPEG_QUALITIES.length; i++) {
                var dataURL = canvas.toDataURL('image/jpeg', JPEG_QUALITIES[i]);
                if(dataURL.length <= MAX_IMAGE_BASE64) {
                    this.previewError = false;
                    //$set y no asignación directa: imgurl viaja con `omitempty`
                    //(models/map.go), así que un mapa sin imagen llega sin la
                    //clave. Asignarla de frente la crea fuera del sistema de
                    //reactividad de Vue 2 y la vista previa se queda pegada en
                    //el placeholder.
                    this.$set(this.map, 'imgurl', dataURL);
                    return;
                }
            }
            this.showImageError('La imagen es demasiado pesada. Usa una imagen más liviana.');
        },
        removeImage: function(){
            this.previewError = false;
            this.map.imgurl = '';
        },
        showImageError: function(message){
            this.$store.dispatch('toast/show', { message: message, type: 'error' });
        }
    }
}
